// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","SubscribedPhotoblogs":"st_a bhf_b bhf_bj","SubscribedPhotoblogs__link":"st_b bhf_a bhf_r"};